import { defineStore } from 'pinia';
import {
  loginApi,
  messageloginApi,
  getLoginUserInfoApi,
  loginOutApi,
  getCaptchaInfoApi,
} from '@/api';
import CONSTANTS from '@/utils/constants';
import { addRoutes, permissionsRouteMap } from '@/router';
import util from '@/utils';
import useSystemStore from '@/store/modules/system';

const menuConfig = {
  superAdmin: ['goods', 'order', 'miniappConfig', 'donate', 'recommend', 'account'],
  common: ['goods', 'order', 'miniappConfig', 'donate'],
};

// 过滤菜单
const filterMenu = item => {
  if (!item) return null;
  if (item.only) {
    const routeItem = {
      ...item,
      children: null,
    };
    return routeItem;
  }
  if (item.children && item.children.length && !item.menuHide) {
    const routeItem = {
      ...item,
      children: item.children.filter(it => !it.menuHide),
    };
    return routeItem;
  }
  return item;
};

export const useUserStore = defineStore('userInfo', {
  state: () => {
    return {
      userId: null,
      nickName: '',
      deptName: '',
      permissions: [],
      isSuperAdmin: false,
    };
  },
  getters: {
    // 树形菜单
    menus(state) {
      return state.permissions.reduce((prev, key) => {
        const item = filterMenu(permissionsRouteMap[key]);
        item && prev.push(item);
        return prev;
      }, []);
    },
  },
  actions: {
    // 登录
    async loginIn(params) {
      const resp = await loginApi(params);
      const code = resp.code;
      if (code === 200) {
        localStorage.setItem(`${CONSTANTS.TOKEN}`, resp.token);
        this.getUserInfo();
      }
      return resp;
    },
    async messageloginIn(params) {
      const resp = await messageloginApi(params);
      const code = resp.code;
      if (code === 200) {
        localStorage.setItem(`${CONSTANTS.TOKEN}`, resp.token);
        this.getUserInfo();
      }
      return resp;
    },
    // 判断是否超管
    judgeIsSuperAdmin(user) {
      const role = user.roles.find(role => role.roleKey == 'superAdmin');
      return Boolean(role);
    },
    // 获取登录用户信息
    async getUserInfo() {
      const systemStore = useSystemStore();
      systemStore.setLoading(true);
      if (this.userInfo) return;
      const resp = await getLoginUserInfoApi();
      systemStore.setLoading(false);
      if (resp.code == 200) {
        const userInfo = resp.user;
        this.userId = userInfo.userId;
        this.deptName = userInfo.dept.deptName;
        this.nickName = userInfo.nickName;
        this.isSuperAdmin = this.judgeIsSuperAdmin(userInfo);
        this.permissions = this.isSuperAdmin
          ? menuConfig.superAdmin
          : menuConfig.common;
        addRoutes(this.permissions);
      }
    },
    // 设置验证码
    async getCaptchaInfo() {
      const resp = await getCaptchaInfoApi();
      if (resp.code === 200) {
        console.log(resp, 'resp,  resp,  resp, ');

        return resp;
      }
      return false;
    },
    // 清除store
    clearStorage() {
      util.removeLocalStorage(CONSTANTS.TOKEN);
      this.userInfo = null;
    },
    // 登出
    async loginOut() {
      await loginOutApi();
      this.clearStorage();
    },
  },
});

export default useUserStore;
